
import produce from 'immer';

import {
    IInitialState,
} from './interface';

import {
    SET_DEFAULT_STATE,
    MESSAGE_HAS_SENT,
} from './constants';

/**
 * initialState
 */
export const initialState: IInitialState = {
    topic: false,
    webchatPath: false,
    botName: false,
    webchatAvailable: false,
    webchatUserData: false,
};

/**
 * appReducer
 * @param state
 * @param action
 */
const uiWebchatReducer = (state: any = initialState, action: any) =>
    produce(state, (draft: IInitialState) => {
        switch (action.type) {
            case SET_DEFAULT_STATE:
                draft.topic = action.defaultState.topic;
                draft.webchatPath = action.defaultState.webchatPath;
                draft.botName = action.defaultState.botName;
                draft.webchatAvailable = false;
                draft.webchatUserData = action.defaultState.userData;
                break;
            case MESSAGE_HAS_SENT:
                draft.webchatAvailable = true;
                break;
        }
    });

export default uiWebchatReducer;
